import { render, staticRenderFns } from "./Switch.vue?vue&type=template&id=c6e0369a&"
import script from "./Switch.vue?vue&type=script&lang=js&"
export * from "./Switch.vue?vue&type=script&lang=js&"
import style0 from "./Switch.vue?vue&type=style&index=0&id=c6e0369a&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c6e0369a')) {
      api.createRecord('c6e0369a', component.options)
    } else {
      api.reload('c6e0369a', component.options)
    }
    module.hot.accept("./Switch.vue?vue&type=template&id=c6e0369a&", function () {
      api.rerender('c6e0369a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/inputs/Switch.vue"
export default component.exports